import React, { PropTypes } from 'react';
import ImportModal from './ImportModal';

const InvoiceModal = ({ caseId, isAAST, targetId }) => (
  <ImportModal
    modalType="invoice"
    caseId={caseId}
    isAAST={isAAST}
    targetId={targetId}
    title="Copie de facture"
    baseUrlForBills="/pco-manager/invoices/bills?caseId="
    baseUrlForBillContent="/pco-manager/invoices/bills/"
  />
);

InvoiceModal.propTypes = {
  caseId: PropTypes.number.isRequired,
  isAAST: PropTypes.bool.isRequired,
  targetId: PropTypes.number,
};

export default InvoiceModal;



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/imports/components/InvoiceModal.js